import type { ProductNode } from 'state/product-description/model';

import { useBlockMetadata } from './useBlockMetadata';
import { useFieldMetadata } from './useFieldMetadata';

export function useBlockOrFieldType(id: string, children?: ReadonlyArray<ProductNode>): string {
  const blockMetadata = useBlockMetadata(id);
  const fieldMetadata = useFieldMetadata(id);

  if (id === '') {
    return 'Blank';
  }
  if (blockMetadata !== undefined && children !== undefined) {
    return blockMetadata.type ?? 'UnknownField';
  } else if (fieldMetadata !== undefined) {
    return fieldMetadata.type ?? 'UnknownField';
  } else {
    return 'UnknownField';
  }
}
